import { i as a } from "./index761.mjs";
import { t as o } from "./index838.mjs";
var i = a, t = o, l = TypeError, s = function(r) {
  if (i(r))
    return r;
  throw new l(t(r) + " is not a function");
};
export {
  s as a
};
